import type { ChartNode, LibraryBlock } from "../build";
import { CARD_SHADOW, motion, rect, text } from "./helpers";

// ---------------------------------------------------------------------------
// Zahlen & Fakten: charts on a card (vector, in the brand's palette)
// ---------------------------------------------------------------------------

const chart = (props: Omit<ChartNode, "kind">): ChartNode => ({ kind: "chart", ...props });

const card = (w: number, h: number) =>
  rect({
    x: 0,
    y: 0,
    w,
    h,
    fill: "background",
    radius: "lg",
    shadow: CARD_SHADOW,
    name: "Karte",
    ...motion("fade"),
  });

export const CHARTS: LibraryBlock[] = [
  {
    id: "diagramm-saeulen-karte",
    title: "Säulendiagramm auf Karte",
    category: "zahlen",
    tags: ["Diagramm", "Chart", "Säulen", "Umsatz", "Statistik", "Kennzahlen", "Quartal"],
    width: 900,
    height: 620,
    anchor: "center",
    nodes: [
      card(900, 620),
      chart({
        chart: "column",
        x: 50,
        y: 45,
        w: 800,
        h: 530,
        title: "Umsatz je Quartal",
        labels: ["Q1", "Q2", "Q3", "Q4"],
        series: [
          { name: "2025", values: [42, 51, 48, 63] },
          { name: "2026", values: [48, 57, 61, 72] },
        ],
        unit: "€",
        legend: "bottom",
        fontSize: 26,
        name: "Diagramm",
        ...motion("slide-up", { delay: 200 }),
      }),
    ],
  },
  {
    id: "diagramm-ring-anteile",
    title: "Ringdiagramm Anteile",
    category: "zahlen",
    tags: ["Diagramm", "Chart", "Donut", "Kreis", "Anteile", "Prozent", "Verteilung"],
    width: 620,
    height: 720,
    anchor: "center",
    nodes: [
      card(620, 720),
      chart({
        chart: "donut",
        x: 45,
        y: 40,
        w: 530,
        h: 640,
        title: "Woher unsere Kunden kommen",
        labels: ["Empfehlung", "Social Media", "Website", "Sonstige"],
        series: [{ name: "Anteil", values: [45, 30, 17, 8] }],
        unit: "%",
        showValues: true,
        legend: "bottom",
        fontSize: 24,
        name: "Diagramm",
        ...motion("zoom", { delay: 200 }),
      }),
    ],
  },
  {
    id: "diagramm-kennzahl-ring",
    title: "Kennzahl im Fortschrittsring",
    category: "zahlen",
    tags: ["Kennzahl", "KPI", "Fortschritt", "Ziel", "Prozent", "Ring", "Diagramm"],
    width: 520,
    height: 640,
    anchor: "center",
    nodes: [
      chart({
        chart: "progress",
        x: 0,
        y: 0,
        w: 520,
        h: 520,
        labels: ["Ziel erreicht"],
        series: [{ name: "Fortschritt", values: [87] }],
        unit: "%",
        hole: 0.74,
        fontSize: 34,
        name: "Fortschrittsring",
        ...motion("pop"),
      }),
      text({
        text: "Spendenziel 2026",
        style: "subline",
        size: 40,
        color: "text",
        x: 0,
        y: 560,
        w: 520,
        align: "center",
        ...motion("fade", { delay: 400 }),
      }),
    ],
  },
  {
    id: "diagramm-linie-wachstum",
    title: "Wachstumskurve",
    category: "zahlen",
    tags: ["Diagramm", "Chart", "Linie", "Wachstum", "Entwicklung", "Besucher", "Trend"],
    width: 960,
    height: 600,
    anchor: "center",
    nodes: [
      card(960, 600),
      chart({
        chart: "area",
        x: 50,
        y: 45,
        w: 860,
        h: 510,
        title: "Besucher pro Monat",
        labels: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun"],
        series: [{ name: "Besucher", values: [1200, 1350, 1280, 1620, 1810, 2050] }],
        fontSize: 26,
        name: "Diagramm",
        ...motion("slide-up", { delay: 200 }),
      }),
    ],
  },
  {
    id: "diagramm-balken-ranking",
    title: "Balkendiagramm Rangliste",
    category: "zahlen",
    tags: ["Diagramm", "Chart", "Balken", "Rangliste", "Top", "Umfrage", "Beliebt"],
    width: 900,
    height: 600,
    anchor: "center",
    nodes: [
      card(900, 600),
      chart({
        chart: "bar",
        x: 50,
        y: 45,
        w: 800,
        h: 510,
        title: "Eure Lieblingssorten",
        labels: ["Schokolade", "Vanille", "Erdbeere", "Pistazie", "Zitrone"],
        series: [{ name: "Stimmen", values: [412, 356, 298, 187, 121] }],
        showValues: true,
        gridlines: false,
        fontSize: 26,
        name: "Diagramm",
        ...motion("slide-right", { delay: 200 }),
      }),
    ],
  },
];
